const TickCircleIcon = () => {
	return (
		<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M6.76961 1.10547C4.07268 1.10547 1.875 3.30315 1.875 6.00008C1.875 8.69701 4.07268 10.8947 6.76961 10.8947C9.46655 10.8947 11.6642 8.69701 11.6642 6.00008C11.6642 3.30315 9.46655 1.10547 6.76961 1.10547ZM9.10924 4.87432L6.33399 7.64957C6.26547 7.71809 6.17247 7.75725 6.07458 7.75725C5.97669 7.75725 5.88369 7.71809 5.81516 7.64957L4.42999 6.26439C4.28804 6.12245 4.28804 5.88751 4.42999 5.74556C4.57193 5.60362 4.80687 5.60362 4.94882 5.74556L6.07458 6.87132L8.59041 4.35549C8.73235 4.21355 8.9673 4.21355 9.10924 4.35549C9.25118 4.49744 9.25118 4.72748 9.10924 4.87432Z"
				fill="#789B73"
			/>
		</svg>
	);
};

export default TickCircleIcon;
